import React from 'react';
import {
  Box,
  Card,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Skeleton
} from '@mui/material';
import useTheme from '../hooks/useTheme';

export default function TableSkeleton({ 
  rows = 10, 
  columns = ['30%', '20%', '15%', '15%', '10%', '10%'] 
}) {
  const theme = useTheme();

  return (
    <Card sx={theme.styles.card}>
      <TableContainer component={Paper} sx={{ ...theme.styles.card, borderRadius: 0 }}>
        <Table>
          <TableHead>
            <TableRow sx={theme.styles.tableHeader}>
              {columns.map((width, index) => (
                <TableCell key={index} sx={theme.styles.tableHeaderCell}>
                  <Skeleton variant="text" width={width} />
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {Array.from({ length: rows }).map((_, rowIndex) => (
              <TableRow key={rowIndex}>
                {columns.map((width, colIndex) => (
                  <TableCell key={colIndex} sx={theme.styles.tableCell}>
                    <Skeleton 
                      variant="text" 
                      width={width}
                      animation="wave"
                    />
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Card>
  );
}
